import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "tab-content",
  id: "myTab7Content"
}
const _hoisted_2 = {
  class: "tab-pane fade",
  id: "code7-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code7-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("ul", {
      class: "nav nav-tabs mb-4 bg-white",
      id: "myTab7",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link active",
          id: "preview7-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#preview7-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "preview7-tab-pane",
          "aria-selected": "true"
        }, " Preview ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "code7-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#code7-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "code7-tab-pane",
          "aria-selected": "false"
        }, " Code ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "tab-pane fade show active",
        id: "preview7-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "preview7-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card bg-white" }, [
          _createElementVNode("div", { class: "card-header fs-16 fw-semibold" }, "Featured"),
          _createElementVNode("ul", { class: "list-group list-group-flush" }, [
            _createElementVNode("li", { class: "list-group-item" }, "An item"),
            _createElementVNode("li", { class: "list-group-item" }, "A second item"),
            _createElementVNode("li", { class: "list-group-item" }, "A third item")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0 mt-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
        }, " Copy "),
        _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "codeCopy"
          }, "\n<div class=\"card bg-white\">\n<div class=\"card-header fs-16 fw-semibold\">\nFeatured\n</div>\n<ul class=\"list-group list-group-flush\">\n<li class=\"list-group-item\">An item</li>\n<li class=\"list-group-item\">A second item</li>\n<li class=\"list-group-item\">A third item</li>\n</ul>\n</div>\n"),
          _createTextVNode("\n")
        ], -1))
      ])
    ])
  ], 64))
}